(() => {
  const hover = window.matchMedia('(hover: hover) and (min-width: 751px)');
  const closeOthers = current => document.querySelectorAll('[data-fuji-nav][open]').forEach(item => {
    if (item !== current) item.open = false;
  });
  const enhance = root => root.querySelectorAll('[data-fuji-nav]').forEach(item => {
    if (item.dataset.navigationReady) return;
    item.dataset.navigationReady = 'true';
    const summary = item.querySelector('summary');
    const group = item.closest('[data-fuji-nav-group]') || item;
    const directLink = group.querySelector(':scope > .fuji-nav-link');
    let closeTimer;
    const isMousePointer = event => !event.pointerType || event.pointerType === 'mouse';
    group.addEventListener('pointerenter', event => {
      clearTimeout(closeTimer);
      if (hover.matches && isMousePointer(event)) { closeOthers(item); item.open = true; }
    });
    group.addEventListener('pointerleave', event => {
      if (hover.matches && isMousePointer(event) && !group.contains(document.activeElement)) {
        closeTimer = setTimeout(() => {
          if (!group.contains(document.activeElement)) item.open = false;
        }, 180);
      }
    });
    item.addEventListener('toggle', () => {
      if (item.open) closeOthers(item);
    });
    group.addEventListener('focusin', () => clearTimeout(closeTimer));
    group.addEventListener('focusout', event => {
      if (!item.closest('.fuji-mobile-menu') && event.relatedTarget && event.relatedTarget !== document.body && !group.contains(event.relatedTarget)) item.open = false;
    });
    group.addEventListener('keydown', event => {
      if (event.key === 'Escape' && item.open) {
        event.preventDefault(); event.stopPropagation();
        item.open = false; summary.focus();
      }
      if (event.key === 'ArrowDown' && (event.target === summary || event.target === directLink)) {
        event.preventDefault(); closeOthers(item); item.open = true;
        item.querySelector('.fuji-mega-panel a')?.focus();
      }
    });
  });
  const syncMobileState = () => {
    document.querySelectorAll('.fuji-mobile-menu').forEach(menu => {
      menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
    });
    document.body.classList.toggle('fuji-menu-open', Boolean(document.querySelector('.fuji-mobile-menu[open]')));
  };
  const closeMobile = (returnFocus = false, except = null) => {
    document.querySelectorAll('.fuji-mobile-menu[open]').forEach(menu => {
      if (menu === except) return;
      menu.open = false;
      if (returnFocus) menu.querySelector(':scope > summary')?.focus();
    });
    syncMobileState();
  };
  const enhanceMobile = root => root.querySelectorAll('.fuji-mobile-menu').forEach(menu => {
    if (menu.dataset.mobileReady) return;
    menu.dataset.mobileReady = 'true';
    menu.addEventListener('toggle', () => {
      syncMobileState();
      if (menu.open) document.dispatchEvent(new CustomEvent('fuji:overlay-open', { detail: { source: menu } }));
    });
  });
  enhanceMobile(document);
  document.addEventListener('fuji:overlay-open', event => {
    const source = event.detail?.source;
    closeOthers(null);
    closeMobile(false, source);
    const search = document.querySelector('details-modal.header__search');
    if (search !== source && search?.isOpen()) search.close(false);
    const cart = document.querySelector('cart-drawer.active');
    if (cart !== source) cart?.close(false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && document.querySelector('.fuji-mobile-menu[open]')) {
      event.preventDefault(); closeMobile(true);
    }
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.fuji-mobile-menu')) closeMobile();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    const followsLink = link && !event.defaultPrevented && event.button === 0 &&
      !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
      (!link.target || link.target === '_self') && !link.hasAttribute('download');
    if (!event.target.closest('.fuji-mobile-menu') || followsLink) closeMobile();
  });
  document.addEventListener('shopify:section:load', event => enhanceMobile(event.target));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(syncMobileState));
  enhance(document);
  document.addEventListener('fuji:navigation-update', () => enhance(document));
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('pointerover', event => {
    const link = event.target.closest('.fuji-desktop-nav>a');
    if (link && hover.matches) closeOthers(null);
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-fuji-nav], [data-fuji-nav-group]')) closeOthers(null);
  });
  window.matchMedia('(max-width: 750px)').addEventListener('change', () => { closeOthers(null); closeMobile(); });
  window.addEventListener('hashchange', () => { closeOthers(null); closeMobile(); });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { closeOthers(null); closeMobile(); }
  });
})();
